export default __webpack_public_path__ + "af500c556d8a173583d0372cb9e11c39.svg";